<article
  class="public-entity-card public-hover-card"
  :class="cardClass"
  :style="cardStyle"
  :role="to ? 'link' : null"
  :tabindex="to ? 0 : null"
  @click="openCard"
  @keydown.enter="openCard"
>
  <div class="public-entity-card__top">
    <div v-if="$slots.badges" class="public-entity-card__top-left">
      <slot name="badges" />
    </div>

    <div v-if="$slots['top-right']" class="public-entity-card__top-right">
      <slot name="top-right" />
    </div>
  </div>

  <div class="public-entity-card__body">
    <component
      :is="to ? 'router-link' : 'h3'"
      class="public-entity-card__title"
      :to="to || undefined"
      @click.stop
    >
      {{ title }}
    </component>
    <div v-if="$slots.description" class="public-entity-card__description">
      <slot name="description" />
    </div>
    <p v-else-if="subtitle">{{ subtitle }}</p>

    <div v-if="$slots.meta" class="public-entity-card__meta">
      <slot name="meta" />
    </div>

    <div v-if="$slots.extra" class="public-entity-card__extra">
      <slot name="extra" />
    </div>
  </div>

  <slot name="actions" />
</article>
